
class FlickityCollectionListCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = null;
    this.thisCarouselElement = this.querySelector('.flickity-collection-list-carousel');
    this.initTimeout = null;
    this.init();

  }

  init() {
    // Check if Flickity is available, if not wait for it
    if (typeof Flickity === 'undefined') {
      // Clear any existing timeout
      if (this.initTimeout) {
        clearTimeout(this.initTimeout);
      }
      
      // Try again after a short delay
      this.initTimeout = setTimeout(() => {
        this.init();
      }, 50);
      return;
    }

    // Clear timeout since Flickity is now available
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
      this.initTimeout = null;
    }

    this.thisCarouselElement.classList.remove('js-flickity-collection-list-carousel__init');

    try {
      this.carousel = new Flickity(this.thisCarouselElement,
        {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          draggable: false,
          selectedAttraction: 0.04,
          friction: 0.3,
          dragThreshold: 20,
          groupCells: true,
          arrowShape: {
            'x0': 25,
            'x1': 60, 'y1': 40,
            'x2': 70, 'y2': 35,
            'x3': 40
          }
        });

      this.calculateSlides();
      this.moveButtons();
    } catch (error) {
      console.error('Failed to initialize Flickity carousel:', error);
      // Fallback: ensure element is visible even without carousel
      this.thisCarouselElement.style.visibility = 'visible';
      this.thisCarouselElement.style.opacity = '1';
    }

  }

  calculateSlides() {

    const cellSizeMobile = this.querySelector('#cellSizeMobile').value;
    const cellSizeTablet = this.querySelector('#cellSizeTablet').value;
    const cellSizeDesktop = this.querySelector('#cellSizeDesktop').value;
    const totalNumberOfSlides = this.carousel.cells.length;
    const buttonGroup = this.querySelector('.collection-list-button-group');

    const mediaQueryMobile = window.matchMedia('(max-width: 749px)');
    const mediaQueryTablet = window.matchMedia('(min-width: 750px) and (max-width: 989px)');
    const mediaQueryDesktop = window.matchMedia('(min-width: 990px)');

    let visibleNumberOfSlides = 0;

    if (mediaQueryMobile.matches) {
      visibleNumberOfSlides = cellSizeMobile;
    } else if (mediaQueryTablet.matches) {
      visibleNumberOfSlides = cellSizeTablet;
    } else if (mediaQueryDesktop.matches) {
      visibleNumberOfSlides = cellSizeDesktop;
    }

    if (totalNumberOfSlides > visibleNumberOfSlides) {
      this.carousel.bindDrag();
      if (!buttonGroup) return
      buttonGroup.classList.remove('js-hidden');
    } else {
      this.carousel.unbindDrag();
      if (!buttonGroup) return
      buttonGroup.classList.add('js-hidden');
    }
  }

  moveButtons() {
    var buttonGroup = this.querySelector('.collection-list-button-group');
    var flickityButtonNext = this.querySelector('.flickity-button.next');
    var flickityButtonPrevious = this.querySelector('.flickity-button.previous');
    if (flickityButtonPrevious) {
      if (!buttonGroup) return
      buttonGroup.appendChild(flickityButtonPrevious);
    }
    if (flickityButtonNext) {
      if (!buttonGroup) return
      buttonGroup.appendChild(flickityButtonNext);
    }
  }

}

// Safari compatibility: Also support DOM content loaded fallback
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    // Re-initialize any failed carousels after DOM is ready
    const failedCarousels = document.querySelectorAll('flickity-collection-list-carousel .js-flickity-collection-list-carousel__init');
    failedCarousels.forEach(carousel => {
      const customElement = carousel.closest('flickity-collection-list-carousel');
      if (customElement && typeof customElement.init === 'function') {
        customElement.init();
      }
    });
  });
}

customElements.define('flickity-collection-list-carousel', FlickityCollectionListCarousel);

class FlickityFeaturedContentCarousel extends HTMLElement {
  constructor() {
    super();

    this.carousel = null;
    this.thisCarouselElement = this.querySelector('.flickity-featured-content-slider');
    this.initTimeout = null;
    this.init();

  }

  init() {
    // Check if Flickity is available, if not wait for it
    if (typeof Flickity === 'undefined') {
      // Clear any existing timeout
      if (this.initTimeout) {
        clearTimeout(this.initTimeout);
      }
      
      // Try again after a short delay
      this.initTimeout = setTimeout(() => {
        this.init();
      }, 50);
      return;
    }

    // Clear timeout since Flickity is now available
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
      this.initTimeout = null;
    }

    this.thisCarouselElement.classList.remove('js-flickity-featured-content-slider__init')

    try {
      this.carousel = new Flickity(this.thisCarouselElement,
        {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          draggable: false,
          selectedAttraction: 0.04,
          friction: 0.3,
          dragThreshold: 20,
          arrowShape: {
            'x0': 25,
            'x1': 60, 'y1': 40,
            'x2': 70, 'y2': 35,
            'x3': 40
          }
        });

      this.CalculateSlides();

      const resizeObserver = new ResizeObserver(entries => this.CalculateSlides());
      resizeObserver.observe(this.thisCarouselElement);
    } catch (error) {
      console.error('Failed to initialize Flickity featured content carousel:', error);
      // Fallback: ensure element is visible even without carousel
      this.thisCarouselElement.style.visibility = 'visible';
      this.thisCarouselElement.style.opacity = '1';
    }

  }

  CalculateSlides() {

    this.totalNumberOfSlides = this.carousel.cells.length;
    this.flickityButtonNext = this.querySelector('.flickity-button.next');
    this.flickityButtonPrevious = this.querySelector('.flickity-button.previous');
    this.buttonGroup = this.querySelector('.featured-content-list-button-group');

    if (window.innerWidth > 990) {
      this.carousel.unbindDrag();
      this.buttonGroup.classList.add('js-hidden');
    } else if (window.innerWidth < 989) {
      if (this.totalNumberOfSlides == 1 || this.totalNumberOfSlides == 2) {
        this.carousel.unbindDrag();
        this.buttonGroup.classList.add('js-hidden');
      } else {
        this.carousel.bindDrag();
        this.buttonGroup.classList.remove('js-hidden');
      }
    }

    if (this.flickityButtonPrevious) {
      this.buttonGroup.appendChild(this.flickityButtonPrevious);
    }
    if (this.flickityButtonNext) {
      this.buttonGroup.appendChild(this.flickityButtonNext);
    }

  }

}
customElements.define('flickity-featured-content-carousel', FlickityFeaturedContentCarousel);

class FlickityMobileNavigation extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this;
    this.mobileNavigation = null;
    this.mobileNavigationElement = this.querySelector('.flickity-mobile-navigation');
    this.initTimeout = null;
    this.init();
  }

  init() {
    // Check if Flickity is available, if not wait for it
    if (typeof Flickity === 'undefined') {
      // Clear any existing timeout
      if (this.initTimeout) {
        clearTimeout(this.initTimeout);
      }
      
      // Try again after a short delay
      this.initTimeout = setTimeout(() => {
        this.init();
      }, 50);
      return;
    }

    // Clear timeout since Flickity is now available
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
      this.initTimeout = null;
    }

    this.mobileNavigationElement.classList.remove('js-flickity-mobile-navigation__init');

    try {
      this.mobileNavigation = new Flickity(this.mobileNavigationElement,
        {
          prevNextButtons: true,
          freeScroll: false,
          pageDots: false,
          contain: true,
          cellAlign: 'left',
          arrowShape: {
            'x0': 20,
            'x1': 55, 'y1': 35,
            'x2': 60, 'y2': 35,
            'x3': 25
          }
        });
    } catch (error) {
      console.error('Failed to initialize Flickity mobile navigation:', error);
      // Fallback: ensure element is visible even without carousel
      this.mobileNavigationElement.style.visibility = 'visible';
      this.mobileNavigationElement.style.opacity = '1';
    }
  }

}
customElements.define('flickity-mobile-navigation', FlickityMobileNavigation);

class MobileDrawerExtendedElement extends HTMLElement {
  constructor() {
    super();

    const childType = this.dataset.link;
    const parentElement = this.previousElementSibling.querySelector(`[data-link-container=${ childType }]`);

    if (parentElement) {
      parentElement.appendChild(this);
    }

  }

}
customElements.define('mobile-drawer-extended-element', MobileDrawerExtendedElement);




